/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgLogin.css";
import { simpleFetch } from "../../restWrapper";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import errorMsg from "../../assets/json/errMsg.json";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { renderOrgLanguageSelector } from "../../assets/component/renderOrgLanguageSelector.js";
import { PLATFORM, COMPANY_NAME } from "../../config";

class OrgLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      username: "",
      errorMsg: "",
      language: this.props.language,
      showSignupButton: false,
    };

    this.handleUsername = this.handleUsername.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }

  handleSubmit(e) {
    if (!this.state.username) {
      this.setState({
        errorMsg: errorMsg[this.state.language].loginErr.loginEmailErr,
      });
      return;
    }
    this.setState({
      loading: true,
    });
    simpleFetch("/organizations/username/", "POST", {
      username: this.state.username,
      expectedType: "organization",
      platform: PLATFORM,
    }).then((res) => {
      this.setState({
        loading: false,
      });
      switch (res.status) {
        case 403:
          this.setState({
            errorMsg: errorMsg[this.state.language].loginErr.acVerify,
          });
          break;
        case 404:
          this.setState({
            errorMsg: errorMsg[this.state.language].loginErr.accountNotFound,
            showSignupButton: true,
          });
          break;
        case 422:
          this.setState({
            errorMsg: errorMsg[this.state.language].loginErr.loginEmailErr,
          });
          break;
        case 200:
          // Check for platform mismatch
          if (res.body.platformMismatch) {
            this.setState({
              errorMsg: errorMsg[this.state.language].loginErr.platformMismatch,
            });
            break;
          }
          // Check if user is an organization user
          if (!res.body.organization) {
            this.setState({
              errorMsg: errorMsg[this.state.language].loginErr.notOrganization,
            });
            break;
          }
          // Proceed to password page
          this.props.history.push({
            pathname: "/OrgLoginPassword",
            state: {
              username: this.state.username,
            },
          });
          break;
        default:
          break;
      }
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="OrgLogin-view">
          <div className="OrgLogin-loadingprompt">
            <this.props.RenderFullPageLoading />
          </div>
        </div>
      );
    }

    const languageObj = this.props.languageObj;
    const signUpCta = languageObj.signUpBtn || "Create organization account";
    const signUpDescription =
      languageObj.signUpDescription ||
      "Create a new organization profile in just a few steps.";

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.handleSubmit();
      }
    };

    return (
      <div className="OrgLogin-view">
        <div className="OrgLogin-prompt">
          <Link to={"/"}>
            <div className="OrgLogin-backContainer">
              <div className="OrgLogin-backBtn" />
            </div>
          </Link>

          <div className="OrgLogin-languageBar">
            <div className="OrgLogin-globe" />
            <div className="OrgLogin-languageSelector">
              {renderOrgLanguageSelector()}
            </div>
          </div>

          <div className="OrgLogin-loginContainer">
            <div className={PLATFORM === "plug" ? "OrgLogin-PlugLogo" : "OrgLogin-CheckPlusLogo"} />

            <div className="OrgLogin-loginText">{languageObj.loginText}</div>
            <div className="OrgLogin-text">{languageObj.text}</div>

            <div className="OrgLogin-inputFieldContainer">
              <div className="OrgLogin-inputContainerLeft">
                <input
                  type="text"
                  value={this.state.username}
                  onChange={this.handleUsername}
                  className="OrgLogin-inputField"
                  placeholder={languageObj.inputField}
                  onKeyDown={handleKeyDown}
                  data-testid="orglogin-username-input"
                />
              </div>
              <div className="OrgLogin-inputContainerRight">
                <div
                  onClick={this.handleSubmit}
                  className="OrgLogin-nextBtn"
                  data-testid="orglogin-submit-btn"
                >
                  <div className="OrgLogin-nextIcn" />
                </div>
              </div>
            </div>

            {renderErrorMsg(this.state.errorMsg)}

            {this.state.showSignupButton && (
              <button
                type="button"
                className="OrgLogin-signupBtn"
                onClick={() =>
                  this.props.history.push({
                    pathname: "/OrgAgreement",
                    state: { username: this.state.username },
                  })
                }
              >
                <span className="OrgLogin-signupCopy">
                  <span className="OrgLogin-signupTitle">{signUpCta}</span>
                  <span className="OrgLogin-signupDescription">
                    {signUpDescription}
                  </span>
                </span>
                <span className="OrgLogin-signupArrow" aria-hidden="true" />
              </button>
            )}

            <div className="OrgLogin-subText">
              {languageObj.subText.replace("CheckPlus", COMPANY_NAME)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
OrgLogin.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default OrgLogin;